import React from "react";
import withFdsIconWrapper from './withFdsIconWrapper';

const DenyIcon = () => <svg viewBox="0 0 24 24"><g fillRule="evenodd"><g><polygon points="10.363961 11.7781746 4 5.41421356 5.41421356 4 11.7781746 10.363961 18.1421356 4 19.5563492 5.41421356 13.1923882 11.7781746 19.5563492 18.1421356 18.1421356 19.5563492 11.7781746 13.1923882 5.41421356 19.5563492 4 18.1421356" /></g></g></svg>;

export default withFdsIconWrapper(DenyIcon);